module.exports = __webpack_public_path__ + "img/50-l.e322c6d5.png";